import {atom} from 'jotai';

export const firmasHolografasAtom = atom([]);
export const visibleModalFirmaHolografa= atom(false);
export const urlFirmaHolografaAtom=atom("");